const { ENV } = require("./envConfig");

// yapi、dev、fat、stage、production
const CLIENT_API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "https://dev.huaban.com/v3",
  fat: "https://fat.huaban.com/v3",
  stage: "https://stage.huaban.com/v3",
  prod: "https://huaban.com/v3",
};

const SERVER_API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "http://api-dev.huaban.com",
  fat: "http://api-fat.huaban.com",
  stage: "https://api-stage.huaban.com",
  prod: "https://api.huaban.com",
};

const BASE_URL =
  typeof window === "undefined" ? SERVER_API[ENV] : CLIENT_API[ENV];

const BIZ_CODE = ["dev", "fat"].includes(ENV) ? "61" : "57";

const BUSINESS_ID = "57";

const CHANNEL_ID = "289";

const GAODING_CHANNEL_ID = "32";

const GAODING_BUSINESS_ID = "13";

const ART_CHANNEL_ID_MAP = {
  yapi: 281,
  dev: 281,
  fat: 321,
  stage: 808,
  prod: 808,
};

const ART_CHANNEL_ID = ART_CHANNEL_ID_MAP[ENV];

module.exports = {
  CLIENT_API,
  SERVER_API,
  BASE_URL,
  BIZ_CODE,
  BUSINESS_ID,
  CHANNEL_ID,
  GAODING_CHANNEL_ID,
  GAODING_BUSINESS_ID,
  ART_CHANNEL_ID_MAP,
  ART_CHANNEL_ID,
};
